import React, { useState } from "react";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import MatchSummary from "./MatchSummary";

const getPositionCSSClass = (position, lastPosition) => {
  var playerPosition = "";
  if (position === 1) {
    playerPosition = "pos-1";
  }
  if (position === 2 || position === 3) {
    playerPosition = "pos-promotion";
  }
  if (position === lastPosition - 1 || position === lastPosition - 2) {
    playerPosition = "pos-playoff-descent";
  }
  if (position === lastPosition) {
    playerPosition = "pos-last";
  }
  return playerPosition;
};

const AdminGroupRow = (player) => {
  const [matchesDetail, setMatchesDetail] = useState(false);
  const cssPosition = getPositionCSSClass(player.position, player.lastPosition);

  return (
    <Wrapper className="section-center">
      <>
        <div className="row">
          <div className={`position ${cssPosition}`} />
          <div className="x1">
            <input
              className="input-text-field x1"
              type="text"
              placeholder="pos"
              name="position"
              value={player.position ? player.position : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
          </div>
          <div className="x3">{player.player}</div>
          <div className="x2">
            <input
              className="input-text-field x2"
              type="text"
              placeholder="puntos"
              name="puntos"
              value={player.points ? player.points : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
          </div>
          <div className="x2">
            <input
              className="input-text-field x1"
              type="text"
              placeholder="wins"
              name="series_win"
              value={player.series_win ? player.series_win : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
            -
            <input
              className="input-text-field x1"
              type="text"
              placeholder="loose"
              name="series_loose"
              value={player.series_loose ? player.series_loose : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
          </div>
          <div className="x2">
            <input
              className="input-text-field x1"
              type="text"
              placeholder="wins"
              name="maps_win"
              value={player.maps_win ? player.maps_win : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
            -
            <input
              className="input-text-field x1"
              type="text"
              placeholder="loose"
              name="maps_loose"
              value={player.maps_loose ? player.maps_loose : ""}
              //onChange={(event) => handleRegChange(event, registration)}
            />
          </div>
          <div className="x3 matches-history">
            {player.history.map((match, index) => {
              var match_result = "hidden";
              var match_result_summary = "?";

              if (match.status === "NOT_STARTED") {
                match_result = "not-played";
              }

              if (match.status === "FINISHED") {
                if (
                  player.registration_id === match.player_a_id &&
                  match.player_a_result > match.player_b_result
                ) {
                  match_result = "win";
                  match_result_summary = match.player_a_result;
                } else if (
                  player.registration_id === match.player_b_id &&
                  match.player_b_result > match.player_a_result
                ) {
                  match_result = "win";
                  match_result_summary = match.player_b_result;
                } else {
                  match_result = "defeat";

                  player.registration_id === match.player_a_id
                    ? (match_result_summary = match.player_a_result)
                    : (match_result_summary = match.player_b_result);
                }
              }

              return (
                <div
                  key={`match-${match.id}-index`}
                  className={`match ${match_result}`}
                >
                  {match_result_summary}
                </div>
              );
            })}
          </div>

          <div
            className="extend-games"
            onClick={() => setMatchesDetail(!matchesDetail)}
          >
            {matchesDetail ? <FaAngleUp /> : <FaAngleDown />}
          </div>
        </div>
        <div
          className={`matches-history-detail ${
            matchesDetail ? "detail-show" : "detail-hidden"
          }`}
        >
          {player.history.map((match) => {
            return (
              <MatchSummary
                key={`matchsummary-${player.registration_id}-${match.id}`}
                {...match}
              />
            );
          })}
        </div>
        <hr />
      </>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .extend-games {
    cursor: pointer;
  }
  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }

  hr {
    border-color: var(--clr-grey-10);
  }
  .x1 {
    width: 2rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x2 {
    width: 6rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x3 {
    width: 28rem;
    margin: 1rem;
  }

  .x4 {
    width: 56rem;
    margin: 1rem;
  }
  .position {
    height: 100%;
    width: 0.5rem;
  }

  .pos-1 {
    background-color: var(--clr-green-dark);
  }

  .pos-promotion {
    background-color: var(--clr-yellow-dark);
  }

  .pos-playoff-descent {
    background-color: var(--clr-red-light);
  }

  .pos-last {
    background-color: var(--clr-red-dark);
  }

  .matches-history {
    display: flex;
  }

  .match {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin: 0.2rem;
  }

  .win {
    background-color: var(--clr-green-dark);
  }

  .defeat {
    background-color: var(--clr-red-dark);
  }

  .not-played {
    background-color: var(--clr-grey-4);
  }

  .hidden {
    background-color: var(--clr-black);
    border: 1px solid var(--clr-grey-1);
  }

  .matches-history-detail {
  }

  .detail-hidden {
    display: none;
  }

  .detail-show {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 1rem;
  }
`;

export default AdminGroupRow;
